export default __webpack_public_path__ + "ef5cdf9c34fd75c99b7716b93a053c1c.png";